import { FETCH_STOCKPILES_DATA } from '../../actions';

export default (state = [], action) => {
	switch (action.type) {
		case FETCH_STOCKPILES_DATA:
			return action.payload;
		default:
			return state;
	}
};
